import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import './style/index.less'
import global from './config/global'
import i18n from './utils/lang/index'



// import 'tailwindcss/tailwind.css';

Vue.use(ElementUI);
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.GLOBAL = global;

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
